import { useLayoutEffect as v } from "react";
function y(m, e) {
  v(() => {
    const r = m.current;
    if (!r || !e)
      return;
    const u = window.ScrollTimeline;
    let f = !0, o = 0, c = 0, s = null;
    const i = (t) => Math.min(Math.max(0, t - c), o), a = () => {
      if (!f || s)
        return;
      const t = r.querySelector("thead:first-child");
      t && (t.style.transform = `translateY(${i(e.scrollTop)}px)`);
    }, x = (t) => {
      s?.cancel(), s = null;
      const n = e.scrollHeight - e.clientHeight;
      if (!u || n <= 0 || o <= 0) {
        a();
        return;
      }
      const p = Math.min(Math.max(0, c / n), 1), b = Math.min(Math.max(0, (c + o) / n), 1);
      t.style.removeProperty("transform");
      try {
        s = t.animate(
          [
            { offset: 0, transform: `translateY(${i(0)}px)` },
            {
              offset: p,
              transform: `translateY(${i(p * n)}px)`
            },
            {
              offset: b,
              transform: `translateY(${i(b * n)}px)`
            },
            { offset: 1, transform: `translateY(${i(n)}px)` }
          ],
          {
            duration: 1,
            fill: "both",
            timeline: new u({ source: e, axis: "block" })
          }
        );
      } catch {
        a();
      }
    }, d = () => {
      const t = r.querySelector("thead:first-child");
      t && (c = r.getBoundingClientRect().top - e.getBoundingClientRect().top - e.clientTop + e.scrollTop, o = Math.max(0, r.offsetHeight - t.offsetHeight), x(t));
    };
    e.addEventListener("scroll", a, { passive: !0 });
    const l = new ResizeObserver(d);
    l.observe(r, { box: "border-box" }), l.observe(e, { box: "border-box" });
    const h = new IntersectionObserver(
      (t) => {
        f = t[0]?.isIntersecting ?? !0, f && a();
      },
      { root: e }
    );
    return h.observe(r), d(), () => {
      e.removeEventListener("scroll", a), l.disconnect(), h.disconnect(), s?.cancel(), r.querySelector("thead:first-child")?.style.removeProperty("transform");
    };
  }, [m, e]);
}
export {
  y as useStickyHeader
};
